export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11505.c0c111d8.jpg";